// Copyright (c) 2026 Digital Asset (Switzerland) GmbH and/or its affiliates. All rights reserved.
// SPDX-License-Identifier: Apache-2.0
import { useCollateralStateV2 } from '@hooks/queries/collateralv2/collateral/useCollateralStateV2';
import { useCallback, useMemo } from 'react';
import { CollateralState as CollateralStateV2 } from '@daml.js/utility-collateral-app-v2/lib/Utility/Collateral/App/Model/State/module';
import TemplateContract from '../../../utils/TemplateContract';
import { CollateralKey, CollateralKeyArgs, getCollateralKey } from './collateralKey';

export const useGetCollateralState = () => {
  const collateralStates = useCollateralStateV2();

  const keyToCollateralState: Map<
    CollateralKey,
    TemplateContract<CollateralStateV2>
  > = useMemo(() => {
    return new Map(
      (collateralStates.data ?? []).map((state) => [getCollateralKey(state.payload), state]),
    );
  }, [collateralStates]);

  const getCollateralState = useCallback(
    (args: CollateralKeyArgs) => {
      return keyToCollateralState.get(getCollateralKey(args));
    },
    [keyToCollateralState],
  );

  return { getCollateralState };
};
